import Drawer from "@mui/material/Drawer";
import { Card, Icon } from "pepsico-ds";
import "./ViewDetails.scss";

const Field = ({ label, value }) => (
  <Card border ellipsis={false} className="partner-details-field">
    <span className="partner-details-field-label">{label}</span>
    <p className="partner-details-field-value">{value || "-"}</p>
  </Card>
);

function ViewDetailsModal({
  isOpen,
  closeModal,
  name,
  description,
  rewardTypes,
  type,
}) {
  return (
    <Drawer
      open={isOpen}
      onClose={closeModal}
      anchor="right"
      classes={{ paper: "partner-details-drawer" }}
    >
      <div className="partner-details-drawer-header">
        <p className="partner-details-drawer-title">Partner Details</p>
        <button
          type="button"
          aria-label="Close"
          className="partner-details-close-button"
          onClick={closeModal}
        >
          <Icon icon="close" />
        </button>
      </div>
      <div className="partner-details-drawer-content">
        <Field label="NAME" value={name} />
        <Field label="REWARD TYPES" value={rewardTypes} />
        {type && <Field label="TYPE" value={type} />}
        <Field label="DESCRIPTION" value={description} />
      </div>
    </Drawer>
  );
}

export default ViewDetailsModal;
